import { fromJS } from 'immutable';
import { AvatarActionTypes } from '../actions/AvatarActions';
const defaultState = fromJS({
  updatedAt: null
});
export default function Avatar(state = defaultState, action) {
  switch (action.type) {
    case AvatarActionTypes.UPDATE_AVATAR:
      {
        if (!action.payload) {
          return state;
        }
        return state.set('updatedAt', action.payload.data.updatedAt);
      }
    default:
      return state;
  }
}